<template>
  <section
    class="absolute top-0 left-0 w-full h-full"
    :class="{ hidden: !partiesActive && !searchActive }"
  >
    <advanced-check-box-filter-modal
      v-if="partiesActive"
      :checked="checkedParties"
      @validate="onCheckedPartiesChanged"
      @close="close"
      :check-box-values="checkBoxParties"
      :title="$t('components.buttons.sorting_button.button_party_filter')"
    />
    <search-filter-modal
      v-if="allowSearch && searchActive"
      @validate="onSearch"
      @close="close"
      :value="search"
    />
  </section>
</template>

<script>
import Vue from "vue";
import SearchFilterModal from "../modals/SearchFilterModal.vue";
import AdvancedCheckBoxFilterModal from "../modals/AdvancedCheckBoxFilterModal.vue";

export default {
  name: "SortingButtonOverlays",
  components: {
    SearchFilterModal,
    AdvancedCheckBoxFilterModal
  },
  props: {
    /**
     * @description Used for communication with the SortingButtons component.
     */
    overlayBus: {
      type: Vue,
      required: true
    },
    lightTheme: {
      type: Boolean,
      default: true
    },
    allowSearch: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      partiesActive: false,
      searchActive: false,
      parties: [],
      checkedParties: [],
      search: ""
    };
  },
  mounted() {
    this.overlayBus.$on("parties", this.showPartySelection);
    this.overlayBus.$on("updateParties", this.updateParties);
    if (this.allowSearch) {
      this.overlayBus.$on("showSearch", this.showSearch);
    }
  },
  methods: {
    close() {
      this.partiesActive = false;
      this.searchActive = false;
      this.parties = [];
      this.checkedParties = [];
      this.search = "";
    },
    showPartySelection(event) {
      this.parties = event.parties;
      this.checkedParties = event.checkedParties;
      this.partiesActive = true;
    },
    updateParties(event) {
      this.parties = event.parties;
      this.checkedParties = event.checkedParties;
    },
    showSearch(search) {
      this.search = search;
      this.searchActive = true;
    },
    onCheckedPartiesChanged(checkedParties) {
      this.overlayBus.$emit("checkedparties", checkedParties);
      this.close();
    },
    onSearch(newValue) {
      this.overlayBus.$emit("search", newValue);
      this.close();
    },
    onKeyUp(event) {
      if (event.keyCode === 13) {
        event.target.blur();
        this.close();
      }
    }
  },
  computed: {
    checkBoxParties() {
      return [...this.parties]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(p => ({
          value: p.id,
          label: p.name
        }));
    }
  }
};
</script>

<style scoped>
.border-2 {
  border-width: 0.125rem;
}
.sorting-button-overlays-inner-scroll {
  max-height: 62vh;
  overflow: scroll;
}
</style>
